import CarpLeaguePage from "./pages/CarpLeaguePage";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import ContactsPage from "./pages/contacts/ContactsPage";
import AuthWrapper from "./components/AuthWrapper";
import LayoutWithNavigation from "./components/LayoutWithNavigation";
import DashboardPage from "./pages/DashboardPage";
import CampionatoPage from "./pages/CampionatoPage";
import UsersPage from "./pages/UsersPage";
import ClassifichePage from "./pages/ClassifichePage";
import LoginPage from "./pages/LoginPage";
import StatsPage from "./pages/stats/StatsPage";
import CompetitionsPage from "./pages/competitions/CompetitionsPage";
import LeaguesPage from "./pages/leagues/LeaguesPage";
import LocationPage from "./pages/locations/LocationPage";
import AboutUsPage from "./pages/about/AboutUsPage";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        {/* Route pubbliche aggiuntive */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/contatti" element={<ContactsPage />} />
        <Route path="/dove-siamo" element={<LocationPage />} />
        <Route path="/chi-siamo" element={<AboutUsPage />} />
        <Route path="/statistiche" element={<StatsPage key="trout" />} />
        <Route path="/gare" element={<CompetitionsPage key="trout" />} />
        <Route path="/carpe/gare" element={<CompetitionsPage key="carpe" />} />
        <Route path="/carpe/campionati" element={<LeaguesPage key="carpe" />} />
        <Route path="/carpe/statistiche" element={<StatsPage key="carpe" />} />
        <Route path="/carpe/dashboard" element={<AuthWrapper><LayoutWithNavigation currentPage="dashboard"><DashboardPage key="carpe" /></LayoutWithNavigation></AuthWrapper>} />
        <Route path="/carpe/leagues" element={<AuthWrapper><LayoutWithNavigation currentPage="campionati"><CampionatoPage key="carpe" /></LayoutWithNavigation></AuthWrapper>} />
        <Route path="/carpe/classifiche" element={<AuthWrapper><LayoutWithNavigation currentPage="classifiche"><CarpLeaguePage /></LayoutWithNavigation></AuthWrapper>} />
        <Route path="/campionati" element={<LeaguesPage key="trout" />} />
        {/* <Route path="/public" element={<PublicPage />} /> */}
        {/* Route protette */}
        <Route
          path="/dashboard"
          element={
            <AuthWrapper>
              <LayoutWithNavigation
                onNavigate={() => {}}
                currentPage="dashboard"
              >
                <DashboardPage />
              </LayoutWithNavigation>
            </AuthWrapper>
          }
        />
        <Route
          path="/leagues"
          element={
            <AuthWrapper>
              <LayoutWithNavigation
                onNavigate={() => {}}
                currentPage="campionati"
              >
                <CampionatoPage />
              </LayoutWithNavigation>
            </AuthWrapper>
          }
        />
        <Route
          path="/users"
          element={
            <AuthWrapper>
              <LayoutWithNavigation onNavigate={() => {}} currentPage="users">
                <UsersPage />
              </LayoutWithNavigation>
            </AuthWrapper>
          }
        />
        <Route
          path="/classifiche"
          element={
            <AuthWrapper>
              <LayoutWithNavigation
                onNavigate={() => {}}
                currentPage="classifiche"
              >
                <ClassifichePage />
              </LayoutWithNavigation>
            </AuthWrapper>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
